import React from 'react'
import imgUrl from '../assets/images/imgUrl'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader';

function Biography() {
  return (
    <div className='homeMainWrapper biographyWrapper'>
        <div className='biographyBackground homeBackground'>
            <div className='upperImage'>
            <img src={imgUrl.smileLogo} alt='smile logo'></img>
            </div>
        </div>

        {/* life story section */}
        <section id='life-story'>
            <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
              <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <div className='iconBackground'>
                <img src={imgUrl.lifeStory} alt='icon'></img>
             </div>
            
             <Typography className='headings sectionHeading blackTitles lifeStorytitle'>Life Story</Typography>

             <Typography className='fw-bold sectionHeading blackTitles subsidaryText'>Early Life, Education & Family</Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
               Born on <b> 4 November 1970, Dr. Huzaifa Khorakiwala </b> is the eldest son of
                Dr. Habil Khorakiwala, the renowned founder of <b> Wockhardt Group. </b>
                Growing up in a family of visionary entrepreneurs and philanthropists
                instilled in him a deep sense of purpose. He pursued excellence from an
                early age, completing his MBA at the prestigious <b className='font-italic '> Yale University </b> in the
               <b className='font-italic '> United States. </b> Armed with world-class education and inspired by his
                father’s legacy, the young <b> Huzaifa </b> returned to <b className='font-italic '> India </b> with a resolve to make
                a difference both in business and in society
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px '>
              <b> Dr. Khorakiwala </b> began his career at <b className='font-italic '> Wockhardt Limited </b> in <b> 1996, </b>
              immersing himself in the family’s healthcare enterprise. Over the next
              decade, he rose, gaining invaluable experience in the pharmaceutical
              industry’s operations and leadership. By the late <b> 2000s, </b> he had honed a
              unique vision: to leverage the success of the family business for broader social impact. In
              <b> 2008, </b>this vision took shape when he championed the
              launch of <b className='font-italic '> Wockhardt Foundation </b> as the group’s dedicated philanthropic
              arm, marking a turning point in his journey.   <b> Dr. Khorakiwala </b> transitioned
              from day-to-day corporate roles to focus on humanitarian work, reflecting
              a profound commitment to giving back.
             </Typography>

            </div>
        </section>

        {/* career milestones section */}

        <section>
            <div className='whiteSection lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

              <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.careerMilestone} alt='icon'></img>
                </div>

            <Typography className='headings sectionHeading'>Career  Milestones & <br />
            Entrepreneurial Ventures</Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Following the establishment of <b> Wockhardt Foundation, Dr. Khorakiwala </b>
                continued to innovate. In the ensuing years, he founded what is today
                known as the <b> I Am Peacekeeper Movement,</b> an online global initiative to
                spread peace and human values at the grassroots. What started as a
                humble movement grew exponentially – now uniting more than <b> 1.8
                million I Am Peacekeeper </b>  across continents. This movement (initially
                known as the <b> World Peacekeepers Movement </b>) harnesses social media and
                community engagement to instil values like Justice, Love & Peace in
                everyday life.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px '>
              Ever the entrepreneur, <b> Dr. Khorakiwala </b> also explored social enterprise.
              Blending business with benevolence, he launched a unique venture
              named <b> Peace Mission </b> – a concept of peace-themed cafés aimed at
              spreading messages of harmony in a casual setting. The first <b> Peace Cafée </b>
              opened its doors in <b className='font-italic '> Mumbai </b>, offering not just food and beverages but also
              peace-inspired merchandise and a space for community dialogue. This
              innovative approach demonstrated his belief that commerce can coexist
              with compassion and that even a coffee shop can catalyse social change. <span className='font-italic'>“Life is about spreading love… a coffee shop is a lovely way in which this
              can be done,” </span>
               he remarked in an interview about the <b> Peace Mission </b>
              venture.
             </Typography>

            </div>
        </section>

        {/* timeline section */}

        <section id='timeline'>
            <div className='dynamicBannerwrapper lifeStoryWrapper timlineWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
                 <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

               <div className='iconBackground'>
                <img src={imgUrl.timeline} alt='icon'></img>
             </div>

             <div className='timelineHeader position-relative'>

              <Typography className='headings sectionHeading blackTitles'>Timeline of Key Events</Typography>

              <div className='birdGraphic birdRight'>
                  <img src={imgUrl.birdRightside} alt='icon'></img>
              </div>

              </div>
              <div className='blueBorder'></div>

            {/* Desktop timeline section */}
              

             <Grid container spacing={2} className="timelineGrid firstGrid mt-10px">
                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year'>
                    <Typography>1970</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>Born in <b className='font-italic '> Mumbai, India, </b> into the  
                     <b> Khorakiwala </b> family (founders
                    of <b> Wockhardt Group </b>).</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year blueYear'>
                    <Typography>1996</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>Earned MBA from <b className='font-italic '> Yale
                    University </b> and joined <br/>
                   <b className='font-italic '> Wockhardt Limited  </b> as a young <br/>
                    executive, contributing to the <br/>
                    family business’s growth.</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                   <div className='year'>
                    <Typography>2000</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>Rapid rise in corporate <br/>
                    responsibilities at <b className='font-italic '>Wockhardt; </b><br/>
                    played a pivotal role in various <br/>
                    divisions, gaining experience <br/>
                    in pharmaceuticals, biotech <br/>
                    and corporate strategy.</Typography> 

                </Grid>

                 <div className='blueBorder firstGridborder'></div>
             </Grid>

             

             <Grid container spacing={2} className="timelineGrid secondGrid">
                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year blueYear'>
                    <Typography>2008</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>Founded <b className='font-italic '> Wockhardt <br/>
                    Foundation </b>  and assumed role <br/>
                    as CEO, dedicating efforts <br/>
                    to organised philanthropy. <br/>
                    Stepped into focussing on <br/>
                    social upliftment through the <br/>
                    foundation.</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year purpleYear'>
                    <Typography>2010</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>Launched the  <b>World Peacekeepers <br/>
                    Movement,</b> now <b> I Am Peacekeeper <br/>
                    Movement, </b>  mobilising millions of 
                    citizens globally for peace advocacy.
                    Under his leadership, <b className='font-italic '> Wockhardt
                    Foundation </b> expanded nationwide,
                    introducing flagship programmes
                    (Mobile 1000, Sanitation drives,
                    Education initiatives) that received
                    widespread acclaim</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                   <div className='year'>
                    <Typography>2016</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'>International recognition <br/>
                peaked – <b> Dr. Khorakiwala </b>  was <br/>
                <b> knighted </b> by the Knights of <br/>
                St. John for his humanitarian <br/>
                contributions . This year <br/>
                he also received multiple <br/>
                honorary doctorates and
                awards.</Typography> 

                </Grid>

                 <div className='blueBorder secondGridborder'></div>
             </Grid>

             

             <Grid container spacing={2} className="timelineGrid thirdGrid">
                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year'>
                    <Typography>2018</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription descLong'>Ventured into social  <br />
                    entrepreneurship with  <br />
                    the <b>  Peace Cafée </b> initiative, <br />
                    marrying the concepts of  <br />
                    business and peace promotion  <br />
                    in everyday life.</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year grayYear'>
                    <Typography>2020</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription descLong'>Navigated <b className='font-italic '> Wockhardt
                    Foundation’s  </b> relief efforts
                    during the COVID-19
                    pandemic, providing critical
                    support to healthcare systems.
                    Articulated insights on public
                    health reforms, becoming
                    a thought leader in postpandemic healthcare strategy</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                   <div className='year blueYear'>
                    <Typography>2025</Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription descLong'>A landmark year <b> – Dr. Khorakiwala </b> <br/>
                chaired the <b> Global Justice, Love & <br/>
                Peace Summit </b>  in <b className='font-italic '> Dubai </b>, hosting <b> 10 <br/>
                Nobel Peace Laureates </b>  (the largest <br/>
                such gathering in history). He also <br/>
                launched <b> Billionaires for Peace, </b>  an <br/>
                elite forum to engage ultra-high-net-<br/>worth individuals in peace-building <br/>
                efforts . In the same year, he was <br/>
                honoured as <b>  Man of the Year 2025 </b> for <br/>
                his outstanding global impact .</Typography> 

                </Grid>

                 <div className='blueBorder secondGridborder'></div>
             </Grid>
              
               <div className='blueBorder'></div>

             <Grid container spacing={2} className="timelineGrid fourthGrid">
                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                  <div className=''>
                    <Typography></Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'></Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents lastEvent d-flex-align-center-justify-center flex-direction-column ">
                  <div className='year purpleYear'>
                    <Typography>2026 <br />
                    <span>(Upcoming)</span></Typography>
                  </div>
                    <Typography className='sectionHeading blackTitles yearlyDescription tabTimelinepara'>Set to host the inaugural
                   <b>  Billionaires for Peace </b> Conclave
                    in <b> Dubai </b> , where Nobel Laureates
                    and 210 influential Billionaire
                    Patrons will convene to advance
                    a new Peace Charter and
                    collaborative humanitarian
                    initiatives.</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 4 , lg:4}} className="keyEvents d-flex-align-center-justify-center flex-direction-column ">
                   <div className=''>
                    <Typography></Typography>
                  </div>
                  <Typography className='sectionHeading blackTitles yearlyDescription'></Typography> 

                </Grid>

                
             </Grid>


             {/* Timeline mobile cards */}
             <div className='mobileTimelinesection'>
              <Grid container spacing={2} className="mobileTimelinegrid">
                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year' title="1970">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                      <Typography className='sectionHeading blackTitles yearlyDescription'>Born in <b className='font-italic '> Mumbai, India </b>, into the  
                     <b> Khorakiwala </b> family (founders
                    of <b className='font-italic '>Wockhardt Group</b>).</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year blueYear' title="1996">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                      <Typography className='sectionHeading blackTitles yearlyDescription'>Earned MBA from <b className='font-italic '> Yale University </b> and joined <b className='font-italic '> Wockhardt Limited </b> 
                      as a young executive, contributing to the family business’s growth.</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year' title="2000">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                      <Typography className='sectionHeading blackTitles yearlyDescription'>Rapid rise in corporate responsibilities at <b className='font-italic '> Wockhardt; </b> played a
                      pivotal role in various divisions, gaining experience in pharmaceuticals,
                      biotech and corporate strategy.</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                 <Card className='timelineCard'>
                     <CardHeader className='year blueYear' title="2008">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                      <Typography className='sectionHeading blackTitles yearlyDescription'>Founded <b className='font-italic '>Wockhardt Foundation </b> and assumed role as CEO,
                      dedicating efforts to organised philanthropy. Stepped into focussing on
                      social upliftment through the foundation.</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year purpleYear' title="2010">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                     <Typography className='sectionHeading blackTitles yearlyDescription'>Launched the <b> World Peacekeepers Movement,</b>  now the <b> I Am
                    Peacekeeper Movement,</b>  mobilising millions of citizens globally for peace
                    advocacy. Under his leadership, <b> Wockhardt Foundation </b> expanded
                    nationwide, introducing flagship programmes (Mobile 1000, sanitation
                    drives, education initiatives) that received widespread acclaim.</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year' title="2016">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                      <Typography className='sectionHeading blackTitles yearlyDescription'>International recognition peaked – <b> Dr. Khorakiwala </b> was knighted
                      by the <b> Knights of St. John </b> for his humanitarian contributions. This year he
                      also received multiple honorary doctorates and awards.</Typography> 
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                  <Card className='timelineCard'>
                     <CardHeader className='year' title="2018">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                     <Typography className='sectionHeading blackTitles yearlyDescription descLong'>Ventured into social entrepreneurship with the <b> Peace Cafée </b>
                    initiative, marrying the concepts of business and peace promotion in
                    everyday life.</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                   <Card className='timelineCard'>
                     <CardHeader className='year' title="2020">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                    <Typography className='sectionHeading blackTitles yearlyDescription descLong'>Navigated <b className='font-italic '> Wockhardt
                    Foundation’s  </b> relief efforts
                    during the COVID-19
                    pandemic, providing critical
                    support to healthcare systems.
                    Articulated insights on public
                    health reforms, becoming
                    a thought leader in postpandemic healthcare strategy</Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                   <Card className='timelineCard'>
                     <CardHeader className='year blueYear' title="2025">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                     <Typography className='sectionHeading blackTitles yearlyDescription descLong'>A landmark year – <b> Dr. Khorakiwala </b> chaired the <b> Global Justice,
                    Love & Peace Summit </b> in <b className='font-italic '> Dubai, </b> hosting <b> 10 Nobel Peace Laureates </b> (the
                    largest such gathering in history). He also launched <b> Billionaires for Peace, </b>
                    an elite forum to engage ultra-high-net-worth individuals in peace-building
                    efforts. In the same year, he was honoured as Man of the Year 2025 for his
                    outstanding global impact.
                    </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid size={{ xs: 12}}>
                   <Card className='timelineCard'>
                     <CardHeader className='year purpleYear' title="2026 (Upcoming)">
                    </CardHeader>
                    <CardContent className='timelineContent'>
                    <Typography className='sectionHeading blackTitles yearlyDescription'>Set to host the inaugural
                   <b>  Billionaires for Peace </b> Conclave
                    in <b className='font-italic '> Dubai </b> , where Nobel Laureates
                    and 210 influential Billionaire
                    Patrons will convene to advance
                    a new Peace Charter and
                    collaborative humanitarian
                    initiatives.</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
             </div>
            </div>
        </section>

        {/* personal insights section */}

        <section id='testimonials'>
            <div className='whiteSection lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
                <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.insights} alt='icon'></img>
                </div>

            <Typography className='headings sectionHeading'>Personal Insights & Testimonials</Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Colleagues and beneficiaries often describe<b> Dr. Khorakiwala </b> as a
                charismatic leader with a heart of gold. He is affectionately known as Dr.
                Huz or Huzaifa Sir by team members, who speak of his ability to inspire
                by example. <span className='font-italic'>“An organisation is only as good as its leader and <b className='font-italic '> Wockhardt Foundation </b>
                has <b className='font-italic '> Dr. Huzaifa Khorakiwala </b>  as its leader – pure of heart and a wonderful
                human being,” </span>  says one testimonial from a foundation team member.
                Those who work closely with him highlight his humility and
                approachability despite his towering achievements. He frequently
                emphasises the philosophy <span className='font-italic'>“Where every smile counts”</span>, ensuring that
                empathy and human values remain at the core of all projects.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px '>
               One anecdote often shared is how <b> Dr. Khorakiwala </b> personally joins
              remote medical camps organised by Mobile 1000 vans. Dressed in simple
              field attire, he listens to patients and encourages volunteers, exemplifying
              servant-leadership. A beneficiary from a village in <b className='font-italic '> Rajasthan </b> once noted,
              <span className='font-italic'>“Dr. Huzaifa didn’t just send doctors to us – he came himself to see our
              needs. That gave us hope that we truly matter.” </span> Such stories abound,
              painting a picture of a leader who is as compassionate as he is visionary.
             </Typography>

            </div>
        </section>

        {/* corporate leadership section */}

        <section id='wockhardt'>
             <div className='dynamicBannerwrapper lifeStoryWrapper corporateWrapper bgWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

                  <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

               <div className='iconBackground'>
                <img src={imgUrl.lifewinsLogo} alt='icon'></img>
             </div>

              <Typography className='headings sectionHeading blackTitles corporateTitle'>Corporate Leadership <br /> 
              – Wockhardt Limited</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                In the corporate realm, <b> Dr. Khorakiwala </b> serves as Executive Director of
               <b>Wockhardt Limited,  </b> a role through which he continues the legacy of his
                family in the pharmaceutical industry. <b className='font-italic '> Wockhardt </b> is <b className='font-italic '> India’s </b> research-driven
                global healthcare enterprise with operations spanning pharmaceuticals,
                biotechnology and a chain of advanced hospitals. With <b> 3 state-of-the-art
                research centres </b> and <b> 7 manufacturing plants </b> worldwide,  <b className='font-italic '> Wockhardt </b> is at
                the forefront of developing antibiotics, biopharmaceutical formulations,
                vaccines and Active Pharmaceutical Ingredients.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px '>
                <b> Dr. Khorakiwala’s </b> leadership at <b className='font-italic '> Wockhardt Limited </b> is characterised by a
                commitment to innovation and social responsibility. He is particularly
                involved in the company’s sustainability initiatives and long-term strategy. Through <b className='font-italic '> Wockhardt’s Sustainability Initiative, </b> he has championed green
                manufacturing practices and ethical healthcare delivery. Under his
                guidance, <b className='font-italic '> Wockhardt </b> has not only pursued business growth but also
                endeavoured to make life-saving medicines accessible and affordable.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px '>
                His dual perspective – as a corporate executive and a humanitarian –
                positions him uniquely. He often bridges discussions between industry and
                social sectors. For example, he has publicly spoken about the impact of
                international trade policies on <b className='font-italic '> India’s </b> pharma industry, bringing attention
                to how global economics affect the availability of medicines. Internally, he
                fosters a culture where medicine and compassion go hand in hand,
                encouraging <b className='font-italic '> Wockhardt </b>  employees to engage in community service and
                volunteerism.
             </Typography>

             </div>
        </section>

        {/* peace and humanitarian section */}

        <section id='peace'>
             <div className='whiteSection lifeStoryWrapper peaceWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
                
                <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.peace} alt='icon'></img>
                </div>

            
            <Typography className='headings sectionHeading'>Humanitarian Initiatives</Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
              <b> Dr. Huzaifa Khorakiwala’s </b> most passionate work lies in his humanitarian
              initiatives. Through various organisations and movements he leads, he
              strives to address both immediate human needs and the broader quest for
              world peace.
             </Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo fw-bold mt-10px'>Wockhardt Foundation (CEO):</Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                Established in <b> 2008, <span className='font-italic '>Wockhardt
                Foundation  </span></b>  is the vehicle of <b> Dr. Huzaifa’s </b> charitable endeavours. As
                CEO, he oversees a multitude of programmes that deliver measurable
                social impact. The Foundation operates on the guiding philosophy
                “Where every smile counts”, reflecting deep empathy for those it serves.
                Its core mission is simple yet profound: to uplift the poor, weak and
                needy across <b className='font-italic '> India. </b>
            </Typography>

            {/* initiatives  */}

            <div className='initiativeBggradient'>

              <div className='mobileInitiative mt-20px'>
                <Typography className='headings sectionHeading blackTitles circleHeading'>Initiatives</Typography>
                <Typography className='sectionHeading blackTitles detailedPersonalinfo'>Under <b> Dr. Khorakiwala’s </b> 
                stewardship, <b> Wockhardt <br />
                Foundation </b>  has launched and
                sustained initiatives such as:</Typography>
              </div>

            <Grid container spacing={2} className="humanitarianGrid mt-30px">
              <Grid size={{ xs: 12,sm:2, md: 2 , lg:2}} className="d-flex-align-center-justify-center flex-direction-column emptyGrid"></Grid>
              <Grid size={{ xs: 12,sm:6, md: 6 , lg:4}} className="d-flex-align-center-justify-center flex-direction-column mainInitiativegrid">
                 <Card className='initiativeCard'>
                   <CardContent>
                    <img src={imgUrl.mobile1000}></img>
                    <Typography className='initiativeTitle'>Mobile 1000: </Typography>
                    <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                       A fleet of mobile medical vans providing free primary healthcare at the doorstep of remote and rural populations. Over the years,<b> Mobile 1000 </b> has touched more than <b> 40 million </b> lives, treating illnesses, vaccinating children and offering preventive care in areas with little to no access to doctors. This flagship programme currently deploys hundreds of vans across <b> 21 states/territories, </b>bringing hope and healing to <b> India’s </b>  hinterlands.
                    </Typography>
                   </CardContent>
                 </Card>
              </Grid>

              <Grid size={{ xs: 12,sm:6, md: 6 , lg:4}} className="d-flex-align-center-justify-center flex-direction-column mainInitiativegrid">
                 <Card className='initiativeCard'>
                   <CardContent>
                    <img src={imgUrl.pronto}></img>
                    <Typography className='initiativeTitle'>Water and Sanitation Projects:</Typography>
                    <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                        These include the installation of clean water facilities and the innovative <b> Pronto Toilet Project, </b> which has provided more than <b> 4,000 toilets </b> to slum communities, significantly enhancing public health and dignity.
                    </Typography>
                   </CardContent>
                 </Card>
              </Grid>
              <Grid size={{ xs: 12,sm:2, md: 2 , lg:2}} className="d-flex-align-center-justify-center flex-direction-column emptyGrid"></Grid>
            </Grid>

            <Grid container spacing={2} className="humanitarianGrid mt-30px">
              <Grid size={{ xs: 12,sm:2, md: 2 , lg:2}} className="d-flex-align-center-justify-center flex-direction-column emptyGrid"></Grid>
              <Grid size={{ xs: 12,sm:6, md: 6 , lg:4}} className="d-flex-align-center-justify-center flex-direction-column mainInitiativegrid">
                 <Card className='initiativeCard d-flex-align-center-justify-center'>
                   <CardContent>
                    <img src={imgUrl.e_learning}></img>
                    <Typography className='initiativeTitle'>Education & Skill Development:</Typography>
                    <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px educationInfo'>
                        Initiatives like <b> E-Learning </b>(digital education in rural schools) and various scholarship schemes for underprivileged youth. These programmes aim to break the cycle of poverty by empowering the next generation.
                    </Typography>
                   </CardContent>
                 </Card>
              </Grid>

              <Grid size={{ xs: 12,sm:6, md: 6 , lg:4}} className="d-flex-align-center-justify-center flex-direction-column mainInitiativegrid">
                 <Card className='initiativeCard d-flex-align-center-justify-center'>
                   <CardContent className='ipadPaddingsocial'>
                    <div className='logosSeries'>
                    <img src={imgUrl.hungerLogo}></img>
                    <img src={imgUrl.khelLogo}></img>
                    <img src={imgUrl.gurLogo}></img>
                    </div>
                    <Typography className='initiativeTitle'>Social Development Campaigns: </Typography>
                    <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                        These encompass diverse initiatives such as <b> The Hunger Project </b> for food drives, <b> Khel Khel Mein </b> focused on play-based learning and awareness, and the <b> Gur+ Dialysis Centre, </b> which has delivered over <b>110,000 dialysis sessions.</b> Additionally, the campaigns include environmental efforts like tree planting, recycling programmes and community sensitisation on hygiene and nutrition.
                    </Typography>
                   </CardContent>
                 </Card>
              </Grid>
              <Grid size={{ xs: 12,sm:2, md: 2 , lg:2}} className="d-flex-align-center-justify-center flex-direction-column emptyGrid"></Grid>
            </Grid>
             </div>
            <div className='position-relative'>
              <span className='initiativeCircle'>
                <Typography className='headings sectionHeading blackTitles circleHeading'>Initiatives</Typography>
                <Typography className='sectionHeading blackTitles detailedPersonalinfo'>Under <b> Dr. Khorakiwala’s </b> 
                stewardship, <b> Wockhardt <br />
                Foundation </b>  has launched and
                sustained initiatives such as:</Typography>
              </span>
            </div>
             

            <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-30px'>The The Foundation’s efforts have earned numerous accolades over the years,
            from government awards to international recognitions. Yet, as <b> Dr.
            Khorakiwala </b> often notes, <span className='font-italic'>“The true reward is seeing a smile on the face
            of someone whose life has improved.”</span></Typography>

             </div>
        </section>

        {/* peacekeeper movement section */}

        <section id='peacekeeper'>
           <div className='dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

               <div className='iconBackground'>
                <img src={imgUrl.peacekeeperLogo} alt='icon'></img>
             </div>

              <Typography className='headings sectionHeading blackTitles corporateTitle'>I Am Peacekeeper Movement</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo fw-bold'>(Founder)</Typography>

              <div className='bgGradient'>
              <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px'>
                In parallel to meeting material needs, <b>Dr. Khorakiwala</b> addresses the
                human spirit through the <b> I Am Peacekeeper Movement (IAPM). </b> Founded
                by him as a global online movement, <b> IAPM </b> aspires to build the world’s
                largest community of peace advocates. It is based on <b> 7 Peace Values:
                Gratitude, Forgiveness, Love, Humility, Giving, Patience and Truth – </b>
                values which <b>Dr. Khorakiwala</b> believes are the universal pillars of peace.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                The movement invites individuals of all backgrounds to take a simple but
                profound pledge: to live by these values daily and promote peace in their
                own communities. Thanks to social media and word-of-mouth, the
                movement has swelled to encompass over <b> 1.8 million I Am Peacekeeper
                worldwide.  </b>These I Am Peacekeeper are ordinary people committed to
                nonviolence, kindness and understanding – from students and teachers to
                business leaders and artists.
                Online, they share stories of practising the peace values, encourage each
                other and amplify messages of hope. Offline, many participate in
                community service and cross-cultural dialogue spurred by the movement’s
                ethos.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                <b>Dr. Khorakiwala</b> often addresses the <b> I Am Peacekeeper Movement </b> through
                video messages, reminding them that <span className='font-italic'>“Peace isn’t a destination — it’s a daily choice we make within ourselves.” </span> The movement’s website (<b>www.iam-peacekeeper.com</b>) provides resources like the <b>I Am Peacekeeper
                Pledge, </b> forums to discuss the <b> 7 Values </b> and a rewards program recognising
                active ambassadors. Under <b> Dr. Khorakiwala’s </b> leadership, <b> IAPM </b> has truly
                become, as he envisioned, a living testimony to humanity’s highest
                aspirations of Justice, Love & Peace.
             </Typography>
             </div>
           </div>
        </section>
      
        {/* global justice section */}

      <section id='summit'>
         <div className='whiteSection lifeStoryWrapper globalJusticewrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
          
          <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
          </div>

          <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.globalJusticeLogo} alt='icon'></img>
                </div>

          <Typography className='headings sectionHeading'>Global Justice <br />
           Love & Peace Summit</Typography>

           <Typography className='sectionHeading blackTitles detailedPersonalinfo fw-bold'>(Chairman)</Typography>

            <div className='bgGradient'>

           <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
               One of <b> Dr. Khorakiwala’s </b> most significant recent initiatives is the <b> Global
              Justice, Love & Peace Summit (GJLPS). </b> As Chairman of this high-profile
              summit series, he has created a platform for world leaders, <b>Nobel
              Laureates </b>and change-makers to convene on issues of peace and global
              justice. 
              The inaugural summit, held on <b> 12–13 April 2025 </b> in <b> Dubai </b>, made
              headlines worldwide for its remarkable assembly of <b> Nobel Peace Prize </b>
              winners – <b> Ten Nobel Laureates </b>graced the stage, sharing one platform in
              an unprecedented show of unity.
             </Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                The summit’s theme, <span className='font-italic'>“One Voice, One Planet: Global Justice, Love &
                Peace,” </span> echoes <b> Dr. Khorakiwala’s </b>conviction that humanity must unite
                across borders to address pressing challenges like conflict, inequality and
                climate change. Over two days, the <b className='font-italic '> Dubai</b> summit facilitated dialogues
                and commitments focused on compassion and collective action.
                A crowning moment was the unveiling of a <b>Global Peace Charter,  </b>lovingly
                termed a <span className='font-italic'>“Love Letter to Humanity”, </span> which outlines principles and actions
                for world peace. Drafted with input from the <b>Nobel Laureates, </b> this charter
                serves as a guiding document for <b>I Am Peacekeeper </b> around the globe.
             </Typography>


             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Beyond speeches and declarations, the Summit is designed to spark onground action. <b> Dr. Khorakiwala </b> ensured the event included interactive
                workshops for youth, networking sessions for NGOs and philanthropists
                and cultural programs underscoring unity in diversity. The summit received
                widespread acclaim and media coverage, amplifying its messages.
             </Typography>

             </div>
         </div>
      </section>

      {/* billionaires for peace section */}

      <section id='billionaires'>

        <div className='dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper billionairesWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

          <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

               <div className='iconBackground'>
                <img src={imgUrl.nobelLogo} alt='icon'></img>
             </div>

             <Typography className='headings sectionHeading blackTitles corporateTitle'>Billionaires for Peace</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo fw-bold'>(Chairman)</Typography>

               <div className='bgGradient'>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Leveraging his connections with global business leaders, <b> Dr. Khorakiwala</b>
                chairs the initiative <b>Billionaires for Nobel Peace – </b>  a network of ultrainfluential individuals dedicated to supporting Nobel-like humanitarian
                initiatives. This forum aligns captains of industry and wealth with the moral
                vision of <b> Nobel Peace Laureates.</b>
                The concept is simple yet powerful: encourage billionaires to contribute
                not just funds but also ideas and influence towards peace-building
                projects, from conflict resolution and education to healthcare and
                environmental sustainability.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-30px'>
                Under <b> Dr. Khorakiwala’s </b> leadership, <b>Billionaires for Nobel Peace</b>is organising
                exclusive conclaves where these eminent personalities can interact directly
                with <b> Nobel Laureates.</b> and each other. The goal is to foster partnerships that
                can scale solutions globally.
                One marquee event is the upcoming <b> Billionaires for Peace Conclave </b>
                scheduled for <b> 12 February 2026 </b> in <b> Dubai, </b> which <b> Dr. Khorakiwala </b> will
                preside over. At this conclave, <b> 7 Nobel Peace Laureates </b> and <b> 210
                Billionaire philanthropists  </b>(referred to as <b>I Am Peacekeeper Patrons</b>) will
                come together to share commitments and launch collaborative projects.
                The Conclave’s motto, <span className='font-italic'> “Where wealth and peace join hands,” </span> aptly
                captures the spirit of this initiative. Through such efforts, <b> Dr. Khorakiwala </b> 
                is effectively channelling the resources of the world’s most powerful
                individuals towards the betterment of humanity.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-30px'>
                From corporate success to humanitarian triumphs, <b> Dr. Huzaifa
                Khorakiwala’s</b> biography is a tapestry of dedication, innovation and
                compassion. It tells the story of a leader who not only dreams of a better
                world but actively works to create it.
             </Typography>
             </div>
        </div>

      </section>
    </div>
  )
}

export default Biography
